import { useEffect, useState } from 'react';

import { unwrapResult } from '@reduxjs/toolkit';
import format from 'date-fns/format';
import Alert from 'react-bootstrap/Alert';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useDispatch, useSelector } from 'react-redux';

import { ProductForm } from './forms/ProductForm';
import { SerialCheckForm } from './forms/SerialCheckForm';

import { updateProduct } from './productSlice';
import {
  clearDetail,
  fetchProductDetail,
  selectProductDetail,
} from './serialCheckSlice';

export function SerialCheck() {
  const dispatch = useDispatch();
  const product = useSelector(selectProductDetail);
  const [alert, setAlert] = useState(null);

  useEffect(() => () => dispatch(clearDetail()), [dispatch]);

  return (
    <Row>
      <Col>
        {product && (
          <>
            <h4>Cập Nhật Serial</h4>
            <hr />
            <ProductForm
              alert={
                alert && <Alert variant={alert.variant}>{alert.content}</Alert>
              }
              disabled={{ productId: true }}
              onSubmit={async (data) => {
                setAlert(null);

                if (!data.installationDate || !data.installationDate) {
                  return;
                }

                const installationDate = format(
                  new Date(data.installationDate),
                  'dd/MM/yyyy'
                );
                const warrantlyExpirationDate = format(
                  new Date(data.warrantlyExpirationDate),
                  'dd/MM/yyyy'
                );

                try {
                  const result = await dispatch(
                    updateProduct({
                      ...data,
                      purchasedPrice: Number(data.purchasedPrice),
                      installationDate,
                      warrantlyExpirationDate,
                    })
                  );

                  unwrapResult(result);
                  setAlert({ variant: 'success', content: 'Thành công!' });
                } catch (e) {
                  setAlert({ variant: 'danger', content: e.message });
                }
              }}
              values={{
                productId: product.productId,
                customerId: product.customer.customerId,
                purchasedPrice: product.purchasedPrice,
                installationDate: format(
                  new Date(product.installationDate),
                  'yyyy-MM-dd'
                ),
                warrantlyExpirationDate: format(
                  new Date(product.warrantlyExpirationDate),
                  'yyyy-MM-dd'
                ),
              }}
            />
          </>
        )}
      </Col>
      <Col md={3}>
        <h4>Kiểm Tra Serial</h4>
        <hr />
        <SerialCheckForm
          onSubmit={async (data, e) => {
            try {
              const result = await dispatch(fetchProductDetail(data.productId));

              unwrapResult(result);
              e.target.reset();
            } catch (e) {}
          }}
        />
      </Col>
    </Row>
  );
}
